module.exports = __webpack_public_path__ + "static/GoogleCloud_Partner-71dd580daaf8c57da1fef374ad167628.png";